import type { Hero, Monster } from './model';

/**
 * Losing streaks hurt: INJURY_LOSSES real losses in a row send the hero to
 * rest for INJURY_MINUTES, so the player switches to another hero meanwhile.
 * A battle left unfinished (reloading the page, closing the tab) counts as a
 * loss (progression.forfeitUnfinished), so reloading no longer dodges it.
 */
export const INJURY_LOSSES = 3;
export const INJURY_MINUTES = 10;

/** Practice (classroom) fights and the weekly boss raid, which is meant to be lost, never count. */
export function countsForInjury(monster: Pick<Monster, 'mode' | 'source'>): boolean {
  return monster.mode !== 'classroom' && monster.source !== 'boss';
}

/** Milliseconds the hero must still rest (0 = ready to fight). */
export function injuredFor(hero: Pick<Hero, 'injuredUntil'> | null | undefined, now = Date.now()): number {
  return Math.max(0, (hero?.injuredUntil ?? 0) - now);
}

/** Whole minutes left to rest, rounded up, for messages. */
export function restMinutes(hero: Pick<Hero, 'injuredUntil'> | null | undefined, now = Date.now()): number {
  return Math.ceil(injuredFor(hero, now) / 60_000);
}

/** Counts one result; returns true when this loss injured the hero. A win clears the streak, a draw leaves it. */
export function recordResult(hero: Hero, result: 'win' | 'loss' | 'draw', now = Date.now()): boolean {
  if (result === 'win') hero.lossStreak = 0;
  if (result !== 'loss') return false;
  hero.lossStreak = (hero.lossStreak ?? 0) + 1;
  if (hero.lossStreak < INJURY_LOSSES) return false;
  hero.lossStreak = 0;
  hero.injuredUntil = now + INJURY_MINUTES * 60_000;
  return true;
}
